import { IconProps } from '.';

const InfoFillIcon = ({ color, customClasses }: IconProps) => {
  return (
    <svg
      aria-hidden={true}
      role="presentation"
      focusable="false"
      className={customClasses}
      xmlns="http://www.w3.org/2000/svg"
      width="1em"
      height="1em"
      viewBox="0 0 20 21"
      fill="none"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M20 10.5C20 16.0228 15.5228 20.5 10 20.5C4.47715 20.5 0 16.0228 0 10.5C0 4.97715 4.47715 0.5 10 0.5C15.5228 0.5 20 4.97715 20 10.5ZM9.25 7.5V6H10.75V7.5H9.25ZM9.25 15.5V9.5H10.75V15.5H9.25Z"
        fill={color || 'var(--color-ui-icon-primary)'}
      />
    </svg>
  );
};

export default InfoFillIcon;
